import React from "react";
import TailwindBox from "library/components/_tailwind/box";
import TailwindList, {
  TailwindListType,
} from "library/components/_tailwind/list/";
import TailwindListItem from "library/components/_tailwind/list/list-item";
import TailwindIcon from "library/components/_tailwind/icon";
import TailwindText from "library/components/_tailwind/text";
import TailwindTranslatedText from "library/components/_tailwind/translated-text";

interface Props {}

const OBSModalTabStep5ForObsSupportPage: React.FunctionComponent<Props> =
  ({}) => {
    return (
      <TailwindBox>
        <TailwindList type={TailwindListType.ol} margin={["ml-3"]}>
          <TailwindListItem>
            <TailwindTranslatedText
              descriptor={{
                id: "broadcast-obs-modal.obs-support.step-1",
                defaultMessage: "Log in to your account",
              }}
            />
          </TailwindListItem>
          <TailwindListItem>
            <TailwindTranslatedText
              descriptor={{
                id: "broadcast-obs-modal.obs-support.step-2",
                defaultMessage: "Go to broadcast page (Go Live)",
              }}
            />
          </TailwindListItem>
          <TailwindListItem>
            <TailwindText display={"inline-flex"} alignItems={"items-center"}>
              <TailwindTranslatedText
                descriptor={{
                  id: "broadcast-obs-modal.obs-support.step-3-prefix",
                  defaultMessage: "Click settings icon (",
                }}
              />
              <TailwindIcon display={"inline"} padding={['px-0.5']} name={"settings_extra"} />)
            </TailwindText>
          </TailwindListItem>
          <TailwindListItem>
            <TailwindTranslatedText
              descriptor={{
                id: "broadcast-obs-modal.obs-support.step-4",
                defaultMessage: 'Click "Use external software (OBS)"',
              }}
            />
          </TailwindListItem>
          <TailwindListItem>
            <TailwindTranslatedText
              descriptor={{
                id: "broadcast-obs-modal.obs-support.step-5",
                defaultMessage: "Click step 5 (Stream URL) and follow instructions",
              }}
            />
          </TailwindListItem>
        </TailwindList>
      </TailwindBox>
    );
  };

export default OBSModalTabStep5ForObsSupportPage;
